import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ApiError, apiFetch } from '../api/client.ts';
import { BroadcastBanner } from './BroadcastBanner.tsx';
import { PortalFooter } from './PortalFooter.tsx';
import { PortalHealthBanner } from './PortalHealthBanner.tsx';
import { PortalNavBar } from './PortalNavBar.tsx';

interface PortalContact {
  id: string;
  organizationId: string;
  email: string;
  name: string | null;
  isRequester: boolean;
  isOrgAdmin: boolean;
  isOrgBilling: boolean;
}

interface Props {
  active?: 'home' | 'tickets' | 'kb' | 'reports' | 'billing' | 'team';
  containerClassName?: string;
  children: React.ReactNode;
}

export function PortalShell({ active, containerClassName, children }: Props): React.ReactElement {
  const navigate = useNavigate();
  const [contact, setContact] = useState<PortalContact | null>(null);

  useEffect(() => {
    apiFetch<{ contact: PortalContact | null }>('/api/portal/auth/me')
      .then((r) => {
        if (!r.contact) {
          navigate('/login', { replace: true, state: { from: window.location.pathname } });
          return;
        }
        setContact(r.contact);
      })
      .catch((err: unknown) => {
        if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
          navigate('/login', { replace: true, state: { from: window.location.pathname } });
        }
      });
  }, [navigate]);

  return (
    <div className="bg-white">
      <PortalHealthBanner />
      <PortalNavBar contact={contact} active={active} />
      {contact && <BroadcastBanner audience="contact" />}
      <main className={containerClassName ?? 'mx-auto max-w-6xl px-6 py-10 sm:px-8'}>
        {children}
      </main>
      <PortalFooter />
    </div>
  );
}
